var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeforeInstallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z",
    fill: "#EFF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8363_3351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 28.1084C19.42 28.2546 19.7074 28.3316 20 28.3316C20.2926 28.3316 20.58 28.2546 20.8333 28.1084L26.6667 24.775C26.9198 24.6289 27.13 24.4188 27.2763 24.1657C27.4225 23.9127 27.4997 23.6256 27.5 23.3334V16.6667C27.4997 16.3744 27.4225 16.0874 27.2763 15.8343C27.13 15.5813 26.9198 15.3712 26.6667 15.225L20.8333 11.8917C20.58 11.7454 20.2926 11.6684 20 11.6684C19.7074 11.6684 19.42 11.7454 19.1667 11.8917L13.3333 15.225C13.0802 15.3712 12.87 15.5813 12.7237 15.8343C12.5775 16.0874 12.5003 16.3744 12.5 16.6667V23.3334C12.5003 23.6256 12.5775 23.9127 12.7237 24.1657C12.87 24.4188 13.0802 24.6289 13.3333 24.775L19.1667 28.1084Z",
    stroke: "#0B5ED7",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 28.3333V20",
    stroke: "#0B5ED7",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7417 15.8333L20 20L27.2584 15.8333",
    stroke: "#0B5ED7",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13.5583L23.75 17.85",
    stroke: "#0B5ED7",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8363_3351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeInstallIcon);
export default __webpack_public_path__ + "static/media/before_install_icon.6442a02ca2b79be0fe482f91e7055645.svg";
export { ForwardRef as ReactComponent };